export const dateFormatter = (queryYear) => {
  const year = queryYear
    ? new Date().getMonth() < 3
      ? `${new Date(queryYear).getFullYear() - 1}-YYYY`
      : `YYYY-${new Date(queryYear).getFullYear() + 1}`
    : "YYYY";
  return year;
};
